import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const ContactIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M10 4.917c.967 0 1.75.783 1.75 1.75 0 .966-.783 1.75-1.75 1.75s-1.75-.784-1.75-1.75c0-.967.783-1.75 1.75-1.75m0 7.5c2.475 0 5.083 1.216 5.083 1.75v.916H4.917v-.916c0-.534 2.608-1.75 5.083-1.75m0-9.084c-1.842 0-3.333 1.492-3.333 3.334C6.667 8.508 8.158 10 10 10s3.333-1.492 3.333-3.333c0-1.842-1.491-3.334-3.333-3.334zm0 7.5c-2.225 0-6.667 1.117-6.667 3.334v2.5h13.334v-2.5c0-2.217-4.442-3.334-6.667-3.334z"
                transform="translate(-932 -586) translate(582 568) translate(350 18)"
            />
        </SvgIcon>
    );
};
